export default __webpack_public_path__ + "static/media/image.prediczo-private-limited.a7124d73.png";